import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '../reducers/auth.reducer';
import { AUTH_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

export const selectLoggedIn = createSelector(selectState, (state: AuthState) => state.loggedIn);
export const selectError = createSelector(selectState, (state: AuthState) => state.error);
